import type { PurposeType } from './checkoutApi.js';
import type { SessionMetadataCheckoutMode, SessionMetadataCollect } from 'pi-kiosk-shared';

export interface PayOnSpotSlaNoticeInput {
  checkoutMode: SessionMetadataCheckoutMode | null;
  collect: SessionMetadataCollect | null;
  purposeType: PurposeType;
}

/** D4 — informational SLA notice only; never blocks pay (G31). */
export function shouldShowPayOnSpotSlaNotice(input: PayOnSpotSlaNoticeInput): boolean {
  if (input.purposeType === 'DONATION') {
    return false;
  }
  if (input.checkoutMode === null || input.collect === null) {
    return false;
  }
  if (input.checkoutMode.channel === 'KIOSK_FIRST') {
    return false;
  }
  return (
    input.checkoutMode.channel === 'MOBILE_FIRST' &&
    input.checkoutMode.selectedMode === 'PAY_NOW_SELF_SERVICE' &&
    input.collect.timing === 'NOW'
  );
}
